import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import { StyledButton } from "../buttons"
import { XIcon } from "../icons"
import { Header } from "../other"

interface IQuestionnaireHeaderProps {
	to: string
}

export const QuestionnaireHeader = observer(({ to }: IQuestionnaireHeaderProps) => {
	const navigate = useNavigate()

	return (
		<Header
			right={
				<StyledButton onClick={() => navigate(to)} style="flex flex-row items-center">
					<XIcon />
				</StyledButton>
			}
		/>
	)
})
